const SERVICE_CALLBACK_PARAMS = ["login", "logout", "prompt"];

type ApplicationReturnConfig = {
  urlCallback?: string | null;
  urlSite?: string | null;
};

const currentOrigin = () => {
  if (typeof window === "undefined") return null;
  return window.location.origin;
};

const getOrigin = (value: string | null | undefined) => {
  try {
    return value ? new URL(value).origin : null;
  } catch {
    return null;
  }
};

export const normalizeConsumerReturnUrl = (
  value: string | null | undefined,
  application: ApplicationReturnConfig | null | undefined,
  origin: string | null = currentOrigin()
) => {
  const rawValue = String(value || "").trim();
  if (!rawValue || rawValue === "null") return null;

  try {
    const url = new URL(rawValue);
    if (!["http:", "https:"].includes(url.protocol)) return null;

    if (origin) {
      const idExpressOrigin = new URL(origin).origin;
      if (url.origin === idExpressOrigin) return null;
    }

    const allowedOrigins = [
      getOrigin(application?.urlCallback),
      getOrigin(application?.urlSite),
    ].filter(Boolean);

    if (!allowedOrigins.includes(url.origin)) return null;

    SERVICE_CALLBACK_PARAMS.forEach((param) => url.searchParams.delete(param));
    return url.toString();
  } catch {
    return null;
  }
};

export const resolveLoginReturnUrl = (
  referer: string | null | undefined,
  application: ApplicationReturnConfig | null | undefined,
  origin: string | null = currentOrigin()
) => {
  return (
    normalizeConsumerReturnUrl(referer, application, origin)
    || normalizeConsumerReturnUrl(application?.urlCallback, application, origin)
    || normalizeConsumerReturnUrl(application?.urlSite, application, origin)
  );
};
